const {beamerInitialize } = require('react-beamer');

var configurationManager = require('../config/configurationManager');
var stringUtil = require('../string/stringUtil');
var localizationUtils = require('../domain/localizationUtils');
var logger = require('../logger/logger');

var initialized;

/* global Beamer */

export function initializeBeamer()
{
    try
    {
        initialized = false;

        if (!stringUtil.areStringSame(configurationManager.getConfig().beamerEnabled, "true") ||
            stringUtil.isStringNullOrEmpty(configurationManager.getConfig().beamerUrl) ||
            stringUtil.isStringNullOrEmpty(configurationManager.getConfig().beamerProductKey))
        return;
        
        beamerInitialize(configurationManager.getConfig().beamerProductKey, 
                     configurationManager.getConfig().beamerUrl,
                     {
                        button: false,
                        multi_user: true,
                        selector: "beamerPlaceHolder"
                     });

        initialized = true;
    }
    catch(error)
    {
        logger.error(`Error occurred while initializing beamer: ${error}`, {}, error);
    }
}


export function isInitialized()
{
    return isInitialized;
}

export function updateBeamer(staff)
{
    try
    {
        if (!isInitialized() || staff == null)
        return;

        Beamer.update({
            filter: `POS ${localizationUtils.getCountry()}`,
            user_firstname: staff.firstName,
            user_lastname: staff.lastName,
            user_id: staff.id,
            user_email: staff.emailAddress,
        });
    }
    catch(error)
    {
        logger.error(`Error occurred while updating beamer. ${error}`, {}, error);
    }
    
    
}
